(function (angular) {
	'use strict';

	angular
		.module('urlModule')
		.factory('urlFactory', [
			'$http',
			'$httpParamSerializer',
			'$location',
			'$rootScope',
			'$timeout',
			'$window',
			'API_BASE_PATH',
			'APP_BASE_PATH',
			'HTTP_STATUS',
			'OAUTH_TOKEN',
			'STATIC_BASE_PATH',
			'Raven',
			urlPropertiesFunction
		]);

	function urlPropertiesFunction(
		$http,
		$httpParamSerializer,
		$location,
		$rootScope,
		$timeout,
		$window,
		API_BASE_PATH,
		APP_BASE_PATH,
		HTTP_STATUS,
		OAUTH_TOKEN,
		STATIC_BASE_PATH,
		Raven) {
		
		var factory = {
			urlContains: urlContains,
			serializeParamsAndCreateUrl: serializeParamsAndCreateUrl,
			prependStaticUrl: prependStaticUrl,
			getUrlParam: getUrlParam,
			getUrlParamAsNumber: getUrlParamAsNumber,
			getUrlParamAsBool: getUrlParamAsBool,
			handleFailedRequest: handleFailedRequest,
			handleServerValidation: handleServerValidation,
			redirect: redirect,
			redirectNewTab: redirectNewTab,
			reload: reload,
			spoofApiError: spoofApiError,
			submitFormById: submitFormById,
			getPromise: getPromise,
			postPromise: postPromise,
			apiGetPromise: apiGetPromise,
			apiPostPromise: apiPostPromise,
			apiPutPromise: apiPutPromise,
			apiDeletePromise: apiDeletePromise
		};
		
		return factory;

		function prependStaticUrl(path) {
			if(path.indexOf(STATIC_BASE_PATH) < 0) {
				return STATIC_BASE_PATH + '/' + path;
			}
			return path;
		}

		function urlContains(value) {
			return $window.location.href.indexOf(value) > -1;
		}
		
		function getUrlParam(value){
			return $location.search()[value];
		}

		function getUrlParamAsNumber(value){
			var param = parseInt($location.search()[value]);
			return isNanFR(param) ? undefined : param;
		}

		function getUrlParamAsBool(value) {
			var param = $location.search()[value];
			return angular.isDefined(param) ? param.toLowerCase() === 'true' : undefined;
		}

		function isNanFR(param) {
			return param !== param;
		}

		function spoofApiError(errorMappings) {
			var fakeReponse = {
				data: {
					fieldErrorMap: {}
				}
			};

			angular.forEach(errorMappings, function(errorMessage, fieldName) {
				errorMessage = typeof errorMessage === 'string' ? [errorMessage] : errorMessage;
				fakeReponse.data.fieldErrorMap[fieldName] = errorMessage;
			});

			return fakeReponse;
		}

		function submitFormById(formId) {
			$timeout(function() {
				$window.document.getElementById(formId).submit();
			});
		}

		function handleServerValidation(form, response, errorOverrides) {
			var validInputs = angular.isDefined(form) &&
					angular.isDefined(response) &&
					angular.isDefined(response.data) &&
					angular.isDefined(response.data.fieldErrorMap);

			var overrides = errorOverrides || {};

			if(validInputs) {
				angular.forEach(response.data.fieldErrorMap, function(errorMessages, fieldName) {
					if(angular.isDefined(overrides[fieldName])) {
						form[fieldName].serverSideErrorMsgs = [overrides[fieldName]];
					} else {
						form[fieldName].serverSideErrorMsgs = errorMessages;
					}
					form[fieldName].$setValidity('serverside', false);
				});
			}
		}

		function handleFailedRequest(response){
			if (response.status === HTTP_STATUS.UNAUTHORIZED) {
				redirect('/login');
			} else {
				$rootScope.ToastFactory.show({
					message: 'An error has occurred. The error has been logged and we&rsquo;ll look into it immediately. If you need assistance, contact us at&nbsp;<a href="mailto:support@fundrise.com">support@fundrise.com</a>.',
					type: 'error'
				});

				if(response.status > 0) {
					Raven.captureMessage('Ajax request failed', {
						tags: {
							status: response.status,
							statusText: response.statusText,
							method: response.config.method,
							endpointUrl: response.config.url
						}
					});
				}
			}
		}

		function getUrlParamSeperator(url) {
			if(url.indexOf('?') !== -1) {
				return '&';
			}

			return '?';
		}

		function serializeParamsAndCreateUrl(targetPath, params) {
			if(targetPath && targetPath.charAt(0) !== '/') {
				targetPath = '/' + targetPath;
			}

			if(angular.isDefined(params)) {
				return targetPath + getUrlParamSeperator(targetPath) + $httpParamSerializer(params);
			} else {
				return targetPath;
			}
		}

		function redirect(path, isRelative) {
			if(isRelative) {
				$window.location.href = path;
			} else {
				$window.location = APP_BASE_PATH + path;
			}
		}

		function redirectNewTab(url) {
			$window.open(url, '_blank');
		}

		function reload(params) {
			if(angular.isDefined(params)) {
				$window.location = serializeParamsAndCreateUrl($window.location.pathname, params); 
			} else {
				$window.location.reload();
			}
		}

		function getPromise(url) {
			return $http.get(APP_BASE_PATH + url);	
		}

		function postPromise(url, payload) {
			return $http.post(APP_BASE_PATH + url, payload);
		}

		function apiGetPromise(url) {
			return $http({
				method: 'GET',
				url: API_BASE_PATH + url,
				headers: {
					authorization: 'Bearer ' + OAUTH_TOKEN
				}
			});
		}
		
		function apiPostPromise(url, data) {
			var httpObject = {
					method: 'POST',
					url: API_BASE_PATH + url,
					headers: {
						authorization: 'Bearer ' + OAUTH_TOKEN
					}
			};
			if(angular.isDefined(data)) {
				httpObject.data = data;
			}
			return $http(httpObject);
		}
		
		function apiPutPromise(url, data) {
			var httpObject = {
					method: 'PUT',
					url: API_BASE_PATH + url,
					headers: {
						authorization: 'Bearer ' + OAUTH_TOKEN
					}
			};
			if(angular.isDefined(data)) {
				httpObject.data = data;
			}
			return $http(httpObject);
		}

		function apiDeletePromise(url) {
			return $http({
				method: 'DELETE',
				url: API_BASE_PATH + url,
				headers: {
					authorization: 'Bearer ' + OAUTH_TOKEN
				}
			});
		}
	}
})(window.angular);